export const DEFAULT_BG_COLOR = '#FFFFFF';
